import { Route, Switch } from "react-router-dom";

import BudgetHistoryModalDeprecationPage from "@faire/prototype-playground/workspace/jy/budget-history-modal-deprecation";

export function JeanYangRoutes() {
  return (
    <Switch>
      <Route path="/jy/budget-history-modal-deprecation" component={BudgetHistoryModalDeprecationPage} />
    </Switch>
  );
}

export const slug = "jy";
